// extracted by mini-css-extract-plugin
export default {"link":"styles_link__sz8FG","buttonsHolder":"styles_buttonsHolder__y4qDg"};